export default "__VITE_ASSET__kERudGxv__"